import { render, staticRenderFns } from "./FrameAssemblyConfigurator.vue?vue&type=template&id=20134252&scoped=true"
import script from "./FrameAssemblyConfigurator.vue?vue&type=script&lang=ts"
export * from "./FrameAssemblyConfigurator.vue?vue&type=script&lang=ts"
import style0 from "./FrameAssemblyConfigurator.vue?vue&type=style&index=0&id=20134252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20134252",
  null
  
)

export default component.exports